import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { useMemo } from 'react';

import { Tabs } from 'app/shared-components/structure';
import { useTopHeader } from 'app/hooks';
import FuseSuspense from '@/@fuse/core/FuseSuspense';

const tabs = [
  {
    label: 'PGDs',
    value: 'pgds',
    path: 'pgds',
  },
  {
    label: 'Categories',
    value: 'categories',
    path: 'categories',
  },
];

export default function PgdManageLayout(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();

  useTopHeader('PGD Manage');

  const selectedTab = useMemo(() => {
    return tabs.find((tab) => location.pathname.includes(tab.path))?.value || tabs[0].value;
  }, [location.pathname]);

  function handleTabChange(_event: React.SyntheticEvent, newValue: string) {
    const newPath = tabs.find((tab) => tab.value === newValue)?.path;
    if (newPath) navigate(`/pgd-manage/${newPath}`, { replace: true });
  }

  return (
    <Box className="grow flex flex-col px-20 py-16 gap-16 bg-neutral-100 overflow-hidden">
      <Box className="flex items-center">
        <Tabs tabs={tabs} selectedTab={selectedTab} handleChange={handleTabChange} />
      </Box>
      <FuseSuspense>
        <Outlet />
      </FuseSuspense>
    </Box>
  );
}
